export interface InputProps {
    processes: any
  }
  
  const CustomTooltip = ({processes}:InputProps) => {
    console.log("processes are:"+processes);
    return(
        <div style={{padding:'10px 15px 0 15px'}}>
            {
                processes.map((pro:string,index:number) =>{
                  return( 
                    <p style={{color:'gray',fontSize:'16px'}}>{processes[index+1]}</p>
                     )
                })
            }
        </div>
    )
}

export default CustomTooltip;